import { authState } from "./authState";
import { clearQueueState } from "./clearQueue";
import { contextMenuState } from "./contextMenu";
import { deviceState } from "./devices";
import { disablingProcessesState } from "./disablingProcesses";
import { playbackState } from "./playbackState";
import { randomModeState } from "./randomMode";
import { albumListState } from "./albumListState";
import { userSettingsState } from "./userSettings";
import { workersState } from "./workers";
import { userProfileState } from "./userProfileState";

const reducers = {
    authState,
    workersState,
    playbackState,
    albumListState,
    deviceState,
    randomModeState,
    disablingProcessesState,
    contextMenuState,
    clearQueueState,
    userProfileState,
    userSettingsState
};

export default reducers;